'use strict';

var _ = require('lodash');
var CogMenuController = function CogMenuController($scope, $rootScope) {
  $scope.optionSet = $scope.optionSet || {};
  var defaults = $scope.optionSet.defaults || {};
  $scope.menus = $scope.optionSet.menus || [];
  $scope.selected = _.cloneDeep(defaults);
  function changeSelectedState(menu, group, opt, multiple) {
    menu = menu || 'no-submenu';
    group = group || 'no-group';
    $scope.selected[menu] = $scope.selected[menu] || {};
    $scope.selected[menu][group] = multiple && $scope.selected[menu][group] || [];
    var ind = $scope.selected[menu][group].indexOf(opt);
    if (ind !== -1) {
      $scope.selected[menu][group].splice(ind, 1);
    } else {
      $scope.selected[menu][group].push(opt);
    }
    return $scope.selected[menu][group];
  }

  //only first-level elements could be non-selectable or disabled
  function getFirstLevelEl(menu, group, opt) {
    return !menu && !group && _.find($scope.menus, {
      id: opt
    });
  }

  //elements are selectable by default
  function isSelectable(el) {
    return !el || el.selectable !== false;
  }

  //elements are enabled by default
  function isDisabled(el) {
    return el && el.disabled === true;
  }
  $scope.changeCogValue = function (e, menu, group, opt, multiple) {
    var toBroadcast;
    var el = getFirstLevelEl(menu, group, opt);
    if (e && isDisabled(el)) {
      return e.stopPropagation();
    }
    if (isSelectable(el)) {
      toBroadcast = changeSelectedState(menu, group, opt, multiple);
    } else {
      toBroadcast = opt;
    }
    var channel = ['cog', $scope.cogId, menu !== 'no-submenu' ? menu : null, group !== 'no-group' ? group : null].filter(function (el) {
      return el;
    }).join(':');
    $rootScope.$broadcast(channel, {
      val: toBroadcast
    });
  };
  $scope.isSelected = function (menu, group, opt) {
    return $scope.selected[menu] && $scope.selected[menu][group] && $scope.selected[menu][group].indexOf(opt) !== -1;
  };
  $scope.$watch('optionSet', function (newValue, oldValue, scope) {
    var newDefaultValues = newValue.defaults || {};
    scope.selected = _.cloneDeep(newDefaultValues);
  }, true);
};
CogMenuController.$inject = ['$scope', '$rootScope'];
module.exports = CogMenuController;